import { ControlledNumberInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { CURRENCY_CHAR } from 'constants/currency';

export const Amount: FC<IFieldFactoryProps> = (props) => {
  const { type, ...other } = props;

  return (
    <ControlledNumberInput
      {...other}
      name={type}
      thousandSeparator=" "
      postfix={CURRENCY_CHAR}
    />
  );
};
